module.exports = __webpack_public_path__ + "img/2-3.5085b1df.jpg";